import { kitsService } from "../../shared/services"
import { DataKits } from "../@types"
import { kitsActions } from "../action-types"

export const kitsChangeModalState = (): kitsActions.IKitsModalState =>({
    type: kitsActions.KITS_MODAL_STATE
})

export const setKitForUpdate = (val: DataKits): kitsActions.IGetKitForUpdate =>({
    type: kitsActions.GET_KIT_FOR_UPDATE,
    payload: val
})

export const setIsKitForUpdate = (val: boolean): kitsActions.IIsKitForUpdate =>({
    type: kitsActions.IS_KITS_FOR_UPDATE,
    payload: val
})

export const createKit = async(data: Partial<DataKits>) =>{
    return await kitsService.create(data)
    .then((res: DataKits) => {return res})
    .catch((err: any) => { return err.message })
}

export const updateKit =async(data: Partial<DataKits>) =>{
    return await kitsService.patch(data?.id!, data)
    .then((res: DataKits) => {return res})
    .catch((err: any) => { return err.message })
}

export const deleteKit = async(id: number) => {
    return await kitsService.remove(id.toString())
    .then((res: any) => {return res})
    .catch((err: any) => { return err.message })
}

export const refreshTableKits = (val: boolean): kitsActions.ISwitchKitsRefreshTable =>({
    type: kitsActions.SWITCH_KITS_REFRESH_TABLE,
    payload: val
})

export const refreshTableKitsProducts = (val: boolean): kitsActions.ISwitchKitsProductsRefreshTable =>({
    type: kitsActions.SWITCH_KITS_PRODUCTS_REFRESH_TABLE,
    payload: val
})
